<template>
  <div id="top">
    <div class="topCont">
      <img src="../assets/logo.png" alt="" class="logo" @click="goIndex">
      <ul>
        <li @click="choose" data-url="index" :class="isClick == 0 ? 'active' : ''" data-index='0'>
            <p>首页</p>
        </li>
        <li @click="choose" data-url="login" :class="isClick == 1 ? 'active' : ''" data-index='1'>
            <p>登陆</p>
        </li>
        <li @click="choose" data-url="register" :class="isClick == 2 ? 'active' : ''" data-index='2'>
            <p>注册</p>
        </li>
        <li @click="choose" data-url="callWay" :class="isClick == 4 ? 'active' : ''" data-index='4'>
            <p>联系方式</p>
        </li>
        <li @click="choose" data-url="pufa" :class="isClick == 5 ? 'active' : ''" data-index='5'>
            <p>普法宣传</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import '../sass/top.min.css'

export default {
  name:'top',
  data(){
    return{
      isClick:0
    }
  },
  methods:{
    //选中
    choose(e){
        this.$myStore.setMessageAction(e.currentTarget.dataset.index);
        this.isClick = e.currentTarget.dataset.index;
        this.$router.push({name: e.currentTarget.dataset.url,query: {}});
    },
    goIndex(){
        this.isClick = null;
        this.$router.push({name: "index",query: {}});
    }
  },
  mounted(){
    this.isClick = this.$root.$options.sharedState.isClick;
  }
}
</script>